import React from 'react';
import Typed from 'react-typed';

import {Section} from '../containers';

const Home = ({api, translate}) => {
	const {welcome_message, professions, user_name, wlcome_btn} = api.getHome();
	return (
		<Section id="home" className="lighten-5 home-wrap" overlay={true}>
			<div className="row">
				<div className="col s12">
					<div className="home-inner">
						<div className="center-align home-content">
							<div className="welcome-text">
								<h1>
									<span className="wlc-color">{translate(welcome_message)}</span>
									{translate(user_name)}
								</h1>
								<Typed
									strings={professions.map(profession => translate(profession))}
									typeSpeed={40}
									backSpeed={50}
									loop/>
								<div className="wlcome-btn">
									<a href="#about" data-section="#about"
									   className="hire-me-btn btn waves-effect waves-light btn-large brand-bg white-text regular-text smooth-scroll hide">
										{translate(wlcome_btn)}
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="section-call-to-area">
				<div className="container">
					<div className="row">
						<a href="#about"
						   className="btn-floating btn-large button-middle call-to-about section-call-to-btn animated btn-show smooth-scroll"
						   data-section="#about">
							<i className="mdi mdi-chevron-down"/>
						</a>
					</div>
				</div>
			</div>
		</Section>
	);
};

export default Home;



// WEBPACK FOOTER //
// ./src/components/sections/Home.js